/**
 * Shop the Look Banner — Dawn Compatible
 * Handles hotspot click interactions and product card toggling
 */

if (!customElements.get('shop-the-look-banner')) {
    class ShopTheLookBanner extends HTMLElement {
        constructor() {
            super();
            this.hotspots = [];
            this.overlay = null;
            this.activeHotspot = null;
        }

        connectedCallback() {
            this.hotspots = this.querySelectorAll('.stl-hotspot');

            this.hotspots.forEach((hotspot) => {
                const trigger = hotspot.querySelector('.stl-hotspot__trigger');
                const closeBtn = hotspot.querySelector('.stl-hotspot__close');

                if (trigger) {
                    trigger.addEventListener('click', (e) => {
                        e.stopPropagation();
                        this.toggleHotspot(hotspot);
                    });
                }

                if (closeBtn) {
                    closeBtn.addEventListener('click', (e) => {
                        e.stopPropagation();
                        this.closeHotspot(hotspot);
                    });
                }
            });

            // Close on Escape key
            document.addEventListener('keydown', (e) => {
                if (e.key === 'Escape') {
                    this.closeAll();
                }
            });

            // Close when clicking outside hotspots
            document.addEventListener('click', (e) => {
                if (!this.contains(e.target)) {
                    this.closeAll();
                }
            });
        }

        toggleHotspot(hotspot) {
            if (hotspot.classList.contains('is-active')) {
                this.closeHotspot(hotspot);
            } else {
                this.openHotspot(hotspot);
            }
        }

        openHotspot(hotspot) {
            // Close any previously open hotspot
            this.closeAll();

            hotspot.classList.add('is-active');
            this.activeHotspot = hotspot;

            const trigger = hotspot.querySelector('.stl-hotspot__trigger');
            if (trigger) {
                trigger.setAttribute('aria-expanded', 'true');
            }

            // Prevent horizontal scroll on mobile
            if (window.innerWidth < 750) {
                document.body.style.overflowX = 'hidden';
            }

            // Auto-position card so it doesn't go off-screen
            this.positionCard(hotspot);
        }

        closeHotspot(hotspot) {
            hotspot.classList.remove('is-active');

            const trigger = hotspot.querySelector('.stl-hotspot__trigger');
            if (trigger) {
                trigger.setAttribute('aria-expanded', 'false');
            }

            if (this.activeHotspot === hotspot) {
                this.activeHotspot = null;
            }
        }

        closeAll() {
            this.hotspots.forEach((hotspot) => {
                hotspot.classList.remove('is-active');
                const trigger = hotspot.querySelector('.stl-hotspot__trigger');
                if (trigger) {
                    trigger.setAttribute('aria-expanded', 'false');
                }
            });

            this.activeHotspot = null;
        }

       positionCard(hotspot) {
            const card = hotspot.querySelector('.stl-hotspot__card');
            if (!card) return;

            const column = hotspot.closest('.stl-banner__column');
            if (!column) return;

            const columnRect  = column.getBoundingClientRect();
            const triggerEl   = hotspot.querySelector('.stl-hotspot__trigger');
            const triggerRect = triggerEl.getBoundingClientRect();
            const relX = (triggerRect.left - columnRect.left + triggerRect.width  / 2) / columnRect.width;
            const relY = (triggerRect.top  - columnRect.top  + triggerRect.height / 2) / columnRect.height;

            card.classList.remove(
                'stl-hotspot__card--below',
                'stl-hotspot__card--above',
                'stl-hotspot__card--left',
                'stl-hotspot__card--right'
            );

            if      (relY < 0.4) card.classList.add('stl-hotspot__card--below');
            else if (relY > 0.6) card.classList.add('stl-hotspot__card--above');
            else if (relX < 0.5) card.classList.add('stl-hotspot__card--right');
            else                 card.classList.add('stl-hotspot__card--left');

            // Mobile: clamp card to viewport — NO requestAnimationFrame
            if (window.innerWidth < 750) {
                // 1. Reset position
                card.style.left      = '0';
                card.style.top       = '0';
                card.style.transform = 'none';
                card.style.marginTop = '0';

                // 2. Force reflow so getBoundingClientRect() returns real dimensions
                void card.offsetWidth;

                // 3. Read accurate measurements
                const hotspotRect = hotspot.getBoundingClientRect();
                const cardRect    = card.getBoundingClientRect();
                const vw=document.documentElement.clientWidth,vh=document.documentElement.clientHeight
                const pad = 8;

                // 4. Ideal position: center card horizontally on the trigger dot
                const isAbove = card.classList.contains('stl-hotspot__card--above');
                const idealVpLeft = triggerRect.left + triggerRect.width  / 2 - cardRect.width  / 2;
                const idealVpTop  = isAbove
                ? triggerRect.top    - cardRect.height - 12
                : triggerRect.bottom + 12;

                // 5. Clamp to viewport bounds
                const clampedLeft = Math.max(pad, Math.min(idealVpLeft, vw - cardRect.width  - pad));
                const clampedTop  = Math.max(pad, Math.min(idealVpTop,  vh - cardRect.height - pad));

                // 6. Convert to hotspot-local coordinates and apply
                card.style.left = (clampedLeft - hotspotRect.left) + 'px';
                card.style.top  = (clampedTop  - hotspotRect.top)  + 'px';
            }
        }
    }

    customElements.define('shop-the-look-banner', ShopTheLookBanner);
}
